import React from "react";
import Checkbox from "@mui/material/Checkbox";
import type { CheckboxProps } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

type LabelPlacement = "end" | "start" | "top" | "bottom";

interface IInput extends CheckboxProps {
  label?: React.ReactNode;
  labelPlacement?: LabelPlacement;
}

function CheckboxInputComponent({
  labelPlacement = "end",
  label,
  sx,
  ...rest
}: IInput) {
  return (
    <FormControlLabel
      control={<Checkbox {...rest} />}
      label={label}
      labelPlacement={labelPlacement}
      sx={[
        {
          fontFamily: "Poppins",
          color: "#2E3034",
          fontSize: "14px",
          fontWeight: "400",
          border: "1px solid #B4B4B4",
          textTransform: "capitalize",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}

export default CheckboxInputComponent;
